var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fileReady)?_c('div',[_c('div',{style:(`height: calc(100vh - ${_vm.minusHeight}px)`),attrs:{"id":`pdf_${_vm.propFileId}`}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }